(function (algolia) {
  'use strict';

  var _ = algolia._;
  
  var PART_TYPES = 'Antennas, Axles & Drive Cups, Balancing Tools, Batteries, Batteries - LiPo, Batteries - NiMH, Battery Boxes & Trays, Bearings, Bell Cranks & Servo Saver Kits, Bluetooth, Boat Parts, Boat-Hull, Bodies, Body-Accessory, Body-Clip, Body Posts, Bulkheads, Bumpers, Camera, Carburetors, Carriers, Cases, Chassis, Clear, Cooling-Fan, Decals, Differentials, Drive Shafts, Dogbones & Universals, Drone-Hull, Electronic Speed Controls, Electronics, Engines, Engine Parts, ESC - Brushed, ESC - Brushless, ESC - Castle, Exhaust Pipes & Headers, Fluids & Oils, Foam-Wheels, Full Kits, Full-Set, Gear Boxes, Glue, Hinge Pin & Mount Kits, Holder, Knuckles & Uprights, Lighting, Metal-Servos, Motor Mounts, Motors, Motors - Brushed, Motors - Brushless, Motors - Castle, Painted, Pinion & Bevel Gears, offroad, Onroad, Radio-Accessories, Receiver Boxes, Receivers, Roll Bar Kits, Roll Cage Kits, Rotors, Rubber Bands, Savox, Screw & Tool Kits, Servo Trays, Servo-Horns, Servo-Saver, Servos, Shock Towers, Shocks & Springs, Skid Plates, Spur Gears, Steering, Steering Links, Suspension, Suspension Arms, Sway Bar Kits, Tires, Tires & Wheels, Transmissions, Transmitters, Turnbuckles & Tie Rods, Tools, Wheel Nut & Hex Hub Kits, Wheel-Accessories, Wheel-Hardware, Wheels, Wires'.split(',');

  var TYPES_TO_WIDGET = {
    slider: { name: 'rangeSlider', hasHeader: true, useDefault: true },
    menu: { name: 'menu', params: { limit: 100 } },
    conjunctive: { name: 'refinementList', params: { operator: 'and', limit: 100 }, hasHeader: true },
    disjunctive: { name: 'refinementList', params: { operator: 'or', limit: 100 }, hasHeader: true },
  };

  var sortByRefined = function sortByRefined (sortFunction) {
    return function (a, b) {
      if (a.refined !== b.refined) {
        if (a.refined) {
          return -1;
        }
        if (b.refined) {
          return 1;
        }
      }
      return sortFunction(a, b);
    };
  };

  /*
   * Sorting functions : Allows to chose in which order you want to display the facets
   * Algolia will always send you back the most relevant values for each facet (the ones
   * with the highest count). These sorting functions won't change which results come back
   * but how they are displayed. To retrieve more results, change the maxValuesPerFacet
   * parameter in your Algolia Dashboard.
   * The default sort function is refined > count > name.
   */
  algolia.facetSortFunctions = {
    sortRanges: sortByRefined(function sortRanges (a, b) {
      if (a.name.length === b.name.length) {
        return a.name.localeCompare(b.name);
      }
      return a.name.length - b.name.length;
    })
  };

  /*
   * Display functions
   * When the object sent back for a facet item doesn't match how you would want it to look
   * like, use a function to reformat it how you want.
   */
  algolia.facetDisplayFunctions = {
    displayRange: function displayRange (value) {
      var format = '',
          values = value.split(':');

      return _.map(values, function (e) {
        return algolia.formatMoney(+e * 100, format).replace(/\.\d+$/, '');
      }).join(' - ');
    }
  }

  algolia.config.facets = _.filter(algolia.config.facets, function (facet) { return facet.enabled || parseInt(facet.enabled); });
  algolia.config.facetsWidgets = _.map(algolia.config.facets, function (facet) {
    var widget = TYPES_TO_WIDGET[facet.type],
        params = _.cloneDeep(widget.params) || {};

    params.container = "[class~='algolia-facet-" + facet.name + "']";
    params.facetName = facet.name;
    params.templates = {};

    if (widget.hasHeader) {
      params.templates.header = function () {
        return algolia.compileTemplate('facet_header').render({ title: facet.title });
      }
    }

    if (!widget.useDefault) {
      params.templates.item = algolia.getTemplate('facet_item');
    }

    // Temporary fix - To remove in the long term
    if (facet.sortFunction) {
      facet.sortBy = facet.sortFunction;
    }

    if (facet.sortBy) {
      if (facet.sortBy.match(/:/)) {
        params.sortBy = facet.sortBy;
      } else if (algolia.facetSortFunctions[facet.sortBy]) {
        params.sortBy = algolia.facetSortFunctions[facet.sortBy];
      } else {
        console.log('Algolia: Warning: Unrecognized sort order: ' + facet.sortBy);
      }
    }

    var displayFunction = algolia.facetDisplayFunctions[facet.displayFunction];
    params.transformData = function (data) {
      var facetData = {};
      if (facet.name === 'tags') {
        for (var i = 0; i < PART_TYPES.length; i++) {
          var partType = PART_TYPES[i];
          if (data.name === partType.trim()) {
            facetData = JSON.parse(JSON.stringify(data));
            facetData.type = {};
            facetData.type[facet.type] = true;
            if (displayFunction) {
              facetData.name = displayFunction(facetData.name);
            }
            break;
          }
        }
      } else if (facet.name === 'meta.model_info.model') {
        if (data.name !== 'Retail Packaged Products') {
          facetData = JSON.parse(JSON.stringify(data));
          facetData.type = {};
          facetData.type[facet.type] = true;
          if (displayFunction) {
            facetData.name = displayFunction(facetData.name);
          }
        }
      } else {
        facetData = JSON.parse(JSON.stringify(data));
        facetData.type = {};
        facetData.type[facet.type] = true;
        if (displayFunction) {
          facetData.name = displayFunction(facetData.name);
        }
      }
      
      return facetData;
    }

    return {
      name: widget.name,
      params: params
    };
  });
  
  var _viewport = function() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window )) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        //return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
      return  e[ a+'Width' ];
    };
  
  $('.mobile-facet').click(function() {
    if( _viewport() < 768 ){
      $(this).toggleClass('active-mobile-facet').parent().find('.toggle-mobile-facet-content').toggleClass('show-mobile-facet');
    }
  });
}(algoliaShopify));
